import HrCalendarPg from "../HR/HrCalendarPg";

function PMCalendarPg() {
  return <HrCalendarPg readOnly />;
}

export default PMCalendarPg;
